import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import { useFareGroupsCompareTableQuery } from '@websky/graphql';
import ModalHeading from '../../../ModalHeading';
import { useTheme } from '../../../theme';
import MediaQuery from '../../../MediaQuery/MediaQuery';
import { useCompareFaresModel } from './../../CompareFares.hook';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import FaresSlider from '../FaresSlider/FaresSlider';
const CompareFares = ({ notes, selectedFare, orderId, selectedFareName }) => {
    const { CompareFares: css } = useTheme('CompareFares');
    const { t } = useTranslation('CompareFares');
    const model = useCompareFaresModel(orderId);
    const { data: compareTable, loading, error } = useFareGroupsCompareTableQuery({
        variables: model.compareTableVariables,
        skip: !model.compareTableVariables.flightId && !model.compareTableVariables.orderId
    });
    const headerRef = React.useRef();
    return (React.createElement(Paper, { classes: { root: css.compareFares } },
        React.createElement(MediaQuery, { minWidth: 'mobile' },
            React.createElement(ModalHeading, { heading: t('Compare fare families') })),
        React.createElement("div", { className: css.container, ref: headerRef },
            loading && (React.createElement("div", { className: css.loaderWrp },
                React.createElement(CircularProgress, { classes: { colorPrimary: css.loader } }))),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement(ErrorMessage, { error: error }),
                React.createElement(FaresSlider, { headerRef: headerRef, isLoading: loading, compareTable: compareTable, selectedFareName: selectedFareName, selectedFare: selectedFare, notes: notes }))))));
};
export default CompareFares;
